import { FunctionComponent } from "react";

import { useAppSelector } from "@/redux/hooks";
import { authSelector } from "@/pages/Public/redux/auth.slice";

import { useIsFeatureActive } from "@/utils/useIsFeatureActive";

import { FeaturesCodes } from "../../Users/enum/codes";

import { AccountStatusCard } from "./AccountStatusCard";
import { ConnectedApps } from "./ConnectedApps";
import { EmailConnection } from "./EmailConnection";
import { LinkedinCard } from "./LinkedinCard";
import { LinkedinEnrichmentCard } from "./LinkedinEnrichmentCard";
import { NonSendingConnectionsCard } from "./NonSendingConnectionsCard";

/**
 * "Connected Accounts" tab. Sending users (`user.linkedinAllowed`) manage their LinkedIn +
 * email connections and connection syncing here. Non-sending users see everything disabled
 * apart from uploading their connections CSV (see NonSendingConnectionsCard).
 */
export const ConnectedAccounts: FunctionComponent = () => {
	const { user } = useAppSelector(authSelector);

	const isSequencerActive = useIsFeatureActive(FeaturesCodes.SEQUENCER);
	const isLiConnectionsEnrichmentActive = useIsFeatureActive(
		FeaturesCodes.LI_CONNECTIONS_ENRICHMENT
	);

	const isSendingUser = !!user?.linkedinAllowed;

	return (
		<div className="flex flex-col gap-4">
			<AccountStatusCard isSendingUser={isSendingUser} />

			{isSendingUser ? (
				<>
					{isSequencerActive && <EmailConnection />}

					<LinkedinCard />

					{isLiConnectionsEnrichmentActive && <LinkedinEnrichmentCard />}
				</>
			) : (
				<NonSendingConnectionsCard />
			)}

			<ConnectedApps />
		</div>
	);
};
